import { createContext, useContext } from "react";
import { ProgramTemplateCategory } from "@growth-machine-llc/stridist-api-client";
import { BaseLibraryFilterContextValues } from "../wrappers/router/coach/CoachLibraryLayout";
import { AllOptionType } from "../constants";

export interface ProgramListFilterContextValues
  extends BaseLibraryFilterContextValues {
  category: ProgramTemplateCategory[] | AllOptionType;
  handleCategoryChange: (
    category: ProgramTemplateCategory[] | AllOptionType,
  ) => void;
}

export const ProgramListFilterContext = createContext<
  ProgramListFilterContextValues | undefined
>(undefined);

export const useProgramListFilterContext = () => {
  const context = useContext(ProgramListFilterContext);
  if (!context) {
    throw new Error(
      "useProgramListFilterContext must be used within ProgramListFilterContext.Provider",
    );
  }
  return context;
};
